import { createMass, massToKilograms, massToPounds, massToOunces, massToGrams } from 'measure-fns';

export const convertWeight = (
  weight: number,
  unit: string | undefined,
  largeUnits = true,
  dynamic = false,
): string => {
  const resolvedUnit = unit ?? 'lb';
  const mass = createMass(weight);
  switch (resolvedUnit) {
    case 'lb':
      if (dynamic) {
        const lbs = massToPounds(createMass(weight), { round: true });
        // eslint-disable-next-line no-magic-numbers
        const oz = massToOunces(createMass(weight), { round: true }) - lbs * 16;
        return `${lbs > 0 ? `${lbs} lb` : ''} ${oz > 0 ? `${oz} oz` : ''}`;
      }
      return largeUnits
        ? `${massToPounds(mass, { round: 1 })} lbs`
        : `${massToOunces(mass, { round: 1 })} oz`;
    case 'kg':
      return largeUnits
        ? `${massToKilograms(mass, { round: 1 })} kg`
        : `${massToGrams(mass, { round: 1 })} g`;
    default:
      throw new Error(`Unsupported unit: ${resolvedUnit}`);
  }
};
